<div *ngFor="let block of finalBlock" [ngSwitch]="block.type">
  <h1 *ngSwitchCase="'header-one'">
    <app-block-item *ngFor="let text of block.content" [text]="text" (stepChange)="handleStepChange($event)"></app-block-item>
  </h1>
  <h2 *ngSwitchCase="'header-two'">
    <app-block-item *ngFor="let text of block.content" [text]="text" (stepChange)="handleStepChange($event)"></app-block-item>
  </h2>
  <h3 *ngSwitchCase="'header-three'">
    <app-block-item *ngFor="let text of block.content" [text]="text" (stepChange)="handleStepChange($event)"></app-block-item>
  </h3>
  <h4 *ngSwitchCase="'header-four'">
    <app-block-item *ngFor="let text of block.content" [text]="text" (stepChange)="handleStepChange($event)"></app-block-item>
  </h4>
  <ol *ngSwitchCase="'ordered-list'">
    <li *ngFor="let item of block.content">
      <span *ngFor="let text of item">
        <app-block-item [text]="text" (stepChange)="handleStepChange($event)"></app-block-item>
      </span>
    </li>
  </ol>
  <ul *ngSwitchCase="'unordered-list'">
    <li *ngFor="let item of block.content">
      <span *ngFor="let text of item">
        <app-block-item [text]="text" (stepChange)="handleStepChange($event)"></app-block-item>
      </span>
    </li>
  </ul>
  <div *ngSwitchDefault>
    <app-block-item *ngFor="let text of block.content" [text]="text" (stepChange)="handleStepChange($event)"></app-block-item>
  </div>
</div>
